// Drizzle schema barrel. Tables are added domain-by-domain during the Step 1 schema port
// (tenancy/identity/RBAC → HR → attendance → leave → payroll → projects → finance → CRM → …).
// Each domain file re-exports here so `import * as schema` in db/index.ts stays complete.

// Batch 1.1 — tenancy + identity + RBAC + settings + employee_details
export * from "./tenancy";
export * from "./identity";
// Better Auth tables (session/account/verification); user model maps onto `users`
export * from "./auth";
export * from "./settings";
export * from "./rbac";
export * from "./employee";

// Batch 1.2 — HR core (departments=teams, designations, skills, docs, appreciations, promotions)
export * from "./hr";
// Batch 1.2 Part B — Letter + Lifecycle modules
export * from "./letter";
export * from "./lifecycle";

// Batch 1.3 — Attendance & shifts + AttendancePolicy module
export * from "./attendance";

// Batch 1.4 — Leave + LeavePolicy module
export * from "./leave";

// Batch 1.5 — Payroll module
export * from "./payroll";

// Batch 1.6 — Projects / Tasks / Time logs
export * from "./projects";

// Batch 1.7 — Finance module (currencies, taxes, invoices, estimates, payments,
// expenses, credit notes, contracts, products, bank accounts, gateways)
export * from "./finance";

// Batch 1.8 — CRM & Support (leads, pipelines, deals, tickets, knowledge base)
export * from "./crm";

// Batch 1.9 — Recruit / Performance / Asset modules + core cross-cutting (custom fields,
// notifications, clients, events, notices, orders, weekly timesheets, countries)
export * from "./recruit";
export * from "./performance";
export * from "./asset";
export * from "./core";
